import en from "./en";
import es from "./es";
import fr from "./fr";

export default {
  en: en,
  es: es,
  fr: fr,
  default: es,
};
